// extracted by mini-css-extract-plugin
export default {"adminTableStyles":"_1dR36___ThreeDContent-module__adminTableStyles"};